import { Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { PreviousPageLocationCacheService } from '../../client-caching/previous-page-cache.service';
import { ChildDependencyResolver } from '../../dependency/child-dependency.resolver';
import { MasterDependencyResolver } from '../../dependency/master-dependency.resolver';
import { BetBuilderDetail } from '../../event-list-shared/coupons/bet-builder/bet-builder-detail.model';
import { CouponDetail, CouponList } from '../../event-list-shared/coupons/coupon.model';
import { CouponService } from '../../event-list-shared/coupons/coupon.service';

@Injectable()
export class CouponListResolver extends MasterDependencyResolver<CouponList, CouponDetail | BetBuilderDetail> {
    constructor(
        dependencyService: CouponService,
        router: Router,
        private urlHelper: UrlHelperService,
    ) {
        super(dependencyService, router);
    }

    getChildRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, result?: CouponList | undefined): string {
        const service = this.dependencyService as CouponService;

        if (!result) {
            return state.url;
        }

        return this.urlHelper.getCouponUrl(result.sport, service.getDetailFallback(result));
    }
}

@Injectable()
export class CouponResolver extends ChildDependencyResolver<CouponList, CouponDetail | BetBuilderDetail> {
    constructor(dependencyService: CouponService, @Optional() previousPageLocationCacheService: PreviousPageLocationCacheService) {
        super(dependencyService, previousPageLocationCacheService);
    }
}
